import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {SMALL, MEDIUM} from '../../helpers/IconSize';
import './DestinationMessage.less';
import {getIconProps} from '../../helpers/helpers';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {emitUrgencyDestinationMessageEvent} from '../../helpers/edap';
import {buildMessage} from '../../helpers/helpers';

const NEW_LINE_PLACEHOLDER = '{NEW_LINE_PLACEHOLDER}';

export default class DestinationMessageComponent extends Component {
    static contextType = TrackingContext;
    static propTypes = {
        /** Optional classname to override the root styling */
        className: PropTypes.string,
        /** Sets size and behavior of font and icon */
        size: PropTypes.string,
        /** Data to use in rendering component */
        destinationMessage: PropTypes.oneOfType([
            PropTypes.shape({
                iconTitleText: PropTypes.shape({
                    icon: PropTypes.string,
                    title: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string,
                    link: PropTypes.shape({
                        linkText: PropTypes.string,
                        linkHref: PropTypes.string
                    })
                })
            }),
            PropTypes.shape({
                iconTitleTextV1: PropTypes.shape({
                    icon: PropTypes.string,
                    title: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string,
                    link: PropTypes.shape({
                        linkText: PropTypes.string,
                        linkHref: PropTypes.string
                    })
                })
            }),
            PropTypes.shape({
                iconTitleTextV3: PropTypes.shape({
                    icon: PropTypes.string,
                    title: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string,
                    link: PropTypes.shape({
                        linkText: PropTypes.string,
                        linkHref: PropTypes.string
                    })
                })
            }),
            PropTypes.shape({
                iconTextV1: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string,
                    link: PropTypes.shape({
                        linkText: PropTypes.string,
                        linkHref: PropTypes.string
                    })
                })
            }),
            PropTypes.shape({
                iconText: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string,
                    link: PropTypes.shape({
                        linkText: PropTypes.string,
                        linkHref: PropTypes.string
                    })
                })
            })
        ]),
        /** If true, changes small greyscale icon to its color variant */
        color: PropTypes.bool,
        /** Set to true in order to hide the component from screen readers */
        ariaHidden: PropTypes.bool
    };

    static defaultProps = {
        className: '',
        size: MEDIUM,
        destinationMessage: {},
        color: false,
        ariaHidden: false
    };

    // eslint-disable-next-line complexity
    static getDestinationMessageContent(destinationMessage) {
        if (destinationMessage) {
            const {iconText, iconTextV1, iconTitleText, iconTitleTextV1, iconTitleTextV3} = destinationMessage;
            return iconText || iconTextV1 || iconTitleText || iconTitleTextV1 || iconTitleTextV3 || {};
        }
        return {};
    }

    componentDidMount() {
        const {messageValueType} = DestinationMessageComponent.getDestinationMessageContent(this.props.destinationMessage);
        if (messageValueType) {
            emitUrgencyDestinationMessageEvent(this.context, messageValueType);
        }
    }

    BASE_CLASS = 'UrgencyDestinationMessage';

    // eslint-disable-next-line complexity
    render() {
        let isNewLine = false;
        const {className, size, destinationMessage, color, ariaHidden} = this.props;
        let {icon, title, message, link} = DestinationMessageComponent.getDestinationMessageContent(destinationMessage);

        if (!message) {
            return null;
        }

        const {style, src} = getIconProps(icon, size, color);
        const smallPrefix = size === SMALL ? '--s' : '';

        if (title && title.includes(NEW_LINE_PLACEHOLDER)) {
            title = title.replace(NEW_LINE_PLACEHOLDER, '');
            isNewLine = true;
        }

        return (
            <div className={`${this.BASE_CLASS} ${className}`} aria-hidden={ariaHidden}>
                {
                    src &&
                    <div className={`${this.BASE_CLASS}__img--${size}`}>
                        <img style={style} src={src} alt={icon} />
                    </div>
                }
                <div className={`${this.BASE_CLASS}__message${smallPrefix}`}>
                    {
                        title &&
                        <span className={`${this.BASE_CLASS}__message${smallPrefix}__title`}><strong>{title}</strong></span>
                    }
                    {
                        isNewLine && <br/>
                    }
                    <span className={`${this.BASE_CLASS}__message${smallPrefix}__text`}>
                        {buildMessage(message, link, `${this.BASE_CLASS}__link`)}
                    </span>
                </div>
            </div>
        );
    }
}
